"use client";

import toast, { ToastBar, Toaster } from 'react-hot-toast';
import { X } from 'lucide-react';

const ToastManager = () => (
    <Toaster
        position="bottom-right"
        containerStyle={{
            bottom: "calc(var(--resource-upload-drawer-offset, 0px) + 16px)",
        }}
    >
        {(t) => (
            <ToastBar toast={t}>
                {({ icon, message }) => (
                    <>
                        {icon}
                        {message}
                        {t.type !== 'loading' && (
                            <button onClick={() => toast.dismiss(t.id)}>
                                <X className="text-sm text-gray-500" />
                            </button>
                        )}
                    </>
                )}
            </ToastBar>
        )}
    </Toaster>
);

export default ToastManager;
